import AUTH_TYPES from './types';

interface State {
	isAuth: boolean;
	data: any;
	isLoading: boolean;
	authError: boolean;
}

const initialState: State = {
	isAuth: false,
	data: {},
	isLoading: false,
	authError: false,
};

const reducer = (state: State = initialState, action: any): State => {
	const { payload, type } = action;
	switch (type) {

		case AUTH_TYPES.ME:
		case AUTH_TYPES.LOGIN: {
			return {
				...state,
				isLoading: true,
			};
		}

		case AUTH_TYPES.SUCCESS_LOGIN: {
			return {
				...state,
				data: payload.data,
				isLoading: false,
				isAuth: true,
				authError: false,
			};
		}
		case AUTH_TYPES.LOGIN_FAILED: {
			return {
				...state,
				isLoading: false,
				isAuth: false,
				authError: true,
			};
		}

		case AUTH_TYPES.LOGOUT: {
			return initialState
		}

		default:
			return state;
	}
};

export default reducer;
